import styled, { css } from 'styled-components';

import { Divider } from 'antd';

export const CreatorDataWrap = styled.div`
  font-size: 12px;
  margin-right: 10px;
  width: 250px;
  padding-top: 15px;
  color: ${props => props.theme.colors.fontSilverLight};
`;

export const CreatorName = styled.div`
  font-weight: 500;
`;

export const Status = styled.span`
  color: ${({ color }) => color};
`;

export const Date = styled.div`
  font-weight: normal;
`;

export const TextWrap = styled.div`
  white-space: pre-wrap;
  word-break: break-all;
`;

export const DeleteIconWrapper = styled.div`
  position: absolute;
  opacity: 0;
  right:0;
  top: 0;

  .ant-popover-message-title {
    white-space: nowrap;
  }
`;

export const LogInfo = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const LogWrap = styled.div`
  position: relative;
  padding-right: ${({ withPadding }) => withPadding ? '20px' : '0px'};

  &:hover {
    ${DeleteIconWrapper} {
      opacity: 1;
    }
  }
`;

export const DividerS = styled(Divider)`
  margin: 15px 0;
`;

export const ChangeLogInfo = styled.div`
  width: 100%;
  height: auto;
  background: ${props => props.theme.colors.lightGreySilver};
  border-radius: 5px;
  padding: 10px;
  
  ul {
    list-style: none;
    margin: 0;
    padding-left: 6px;
    
    .child-list {
      padding-left: 14px;
    }
  }
  

  ul li::before {
    content: "\\2022";
    color: ${props => props.theme.colors.lightDark};
    font-weight: bold;
    display: inline-block; 
    width: 1em;
    margin-left: -5px;
  }
`;

export const LogText = styled.span`
  font-style: normal;
  font-weight: ${({ bold }) => bold ? 400 : 300};
  font-size: 13px;
  line-height: 130%;
  color: ${({ goldText, theme }) => goldText ? theme.colors.backgroundGold : theme.colors.fontSilverPrimary};
  ${({ active }) => active && css`
    cursor: pointer;
  `};
  ${({ itemIsDeleted }) => itemIsDeleted && css`
    cursor: not-allowed;
  `};
`;

export const LogTextAttachmentFile = styled.span`
  font-weight: 400;
  
  a {
    font-size: 13px;
    text-decoration: none;
    color: ${props => props.theme.colors.backgroundGold};
  }
`;

export const NewItem = styled.li`
  cursor: pointer;
`;

export const TaskItem = styled.span`
  cursor: ${({ taskIsDeleted }) => taskIsDeleted ? 'not-allowed' : 'pointer'};
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  color: ${props => props.theme.colors.backgroundGold};
`;

export const Label = styled.div`
  display: inline-block;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 5px;
  width: max-content;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${props => props.bgColor};
  margin: 1px;
`;



// WEBPACK FOOTER //
// ./src/components/logs-simple-list/styles.js